function escapeHtml(s: string) {
  return s
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
}

/** Plain-text DB seeds → simple HTML; TipTap HTML passes through. */
export function policyBodyToHtml(raw: string) {
  const s = String(raw || '').trim()
  if (!s) return ''
  if (/<[a-z][\s\S]*>/i.test(s)) return s
  return s
    .split(/\n{2,}/)
    .map((block) => {
      const lines = block
        .split('\n')
        .map((l) => l.trim())
        .filter(Boolean)
      if (!lines.length) return ''
      if (lines.length === 1 && lines[0].length < 80 && !/[.!?]$/.test(lines[0])) {
        return `<h2>${escapeHtml(lines[0])}</h2>`
      }
      return `<p>${lines.map(escapeHtml).join('<br />')}</p>`
    })
    .join('')
}
